
export default  {
    IDLE:"IDLE",
    MOVING_INTO_POSITIONS : "MOVING_INTO_POSITIONS",
    SETTING_ACTUAL_PERIOD : "SETTING_ACTUAL_PERIOD",
    SWAP_COMPLETED : "SWAP_COMPLETED"
}